export enum PromotionalBannerStatus {
  ACTIVE = 'A',
  BLOCKED = 'B',
  DELETED = 'D',
}

export interface PromotionalBanner {
  sno: string;
  title: string;
  description: string;
  image: {
    alt: string;
    description: string;
    path: string;
  };
  status: PromotionalBannerStatus;
  createdDate: number;
  locationId?: string;
  locationName?: string;
  locationNameEng?: string;
}

export interface GetPromotionalBannerListParams {
  fromDate?: number;
  toDate?: number;
  search?: string;
  row?: number;
  fetch?: number;
}

export interface GetPromotionalBannerDetailParams {
  promotionId: string;
}

export interface AddPromotionalBannerPayload {
  title: string;
  description: string;
  image: string;
  locationId: string;
}

export interface UpdatePromotionalBannerPayload {
  promotionalId: string;
  title: string;
  description: string;
  image: string;
  locationId: string;
}

export interface UpdatePromotionalBannerStatusPayload {
  promotionalId: string;
  status: PromotionalBannerStatus;
}

export interface DeletePromotionalBannerPayload {
  promotionalId: string;
  status: PromotionalBannerStatus;
}
